import {EventEmitter, Injectable, InjectionToken, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {fromEvent} from 'rxjs/index';
import {debounceTime} from 'rxjs/internal/operators';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class HtmlUtilsService implements OnInit, OnDestroy {

  renderer: Renderer2;
  document: InjectionToken<Document>;
  contrast = false;
  aPlusSize = false;
  aPlusPlusSize = false;
  searchInText = false;
  mobileVersion = false;
  fullPageVersion = false;
  defaultLang: BehaviorSubject<string> = new BehaviorSubject<string>('PL');

  windowResize = new EventEmitter<number>();

  highContrast = new EventEmitter<boolean>();
  aPlus = new EventEmitter<boolean>();
  aPlusPlus = new EventEmitter<boolean>();
  mobileBehaviorSubject = new BehaviorSubject<boolean>(false);
  fullPageBehaviorSubject = new BehaviorSubject<boolean>(false);
  searchInTextEmitter = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
    this.initData();
    this.initSpecialButtonsEvents();
    fromEvent(window, 'resize').pipe(
      debounceTime(300)
    ).subscribe(value => {
      this.windowResize.emit(window.innerWidth);
    });
    this.windowResize.subscribe(value => {
      this.mobileVersion = value <= 768;
      this.mobileBehaviorSubject.next(this.mobileVersion);

      this.fullPageVersion = value > 1023;
      this.fullPageBehaviorSubject.next(this.fullPageVersion);
    });
  }

  ngAfterViewInit() {
    this.windowResize.emit(window.innerWidth);
  }

  ngOnDestroy(): void {
    this.searchInTextEmitter.unsubscribe();
    this.highContrast.unsubscribe();
    this.aPlus.unsubscribe();
    this.aPlusPlus.unsubscribe();
    this.windowResize.unsubscribe();
    this.mobileBehaviorSubject.unsubscribe();
    this.fullPageBehaviorSubject.unsubscribe();
  }



  toggleContrast() {
    this.contrast = !this.contrast;
    this.highContrast.emit(this.contrast);
  }

  togglePlusSize() {
    this.aPlusSize = !this.aPlusSize;
    if (this.aPlusPlusSize) {
      this.aPlusPlusSize = false;
    }
    this.aPlus.emit(this.aPlusSize);
  }


  togglePlusPlusSize() {
    this.aPlusPlusSize = !this.aPlusPlusSize;
    if (this.aPlusSize) {
      this.aPlusSize = false;
    }
    this.aPlusPlus.emit(this.aPlusPlusSize);
  }

  resetPlusSize() {
    this.aPlusSize = false;
    this.aPlusPlusSize = false;
    this.aPlusPlus.emit(false);
    this.aPlus.emit(false);
  }

  toogleSearchInTextCheckbox(value: boolean) {
    this.searchInTextEmitter.emit(value);
  }

  private initSpecialButtonsEvents() {
    this.highContrast.subscribe((contrast) => {
      this.modifyHtmlClass(document.body, 'high-contrast', contrast, []);
    });

    this.aPlus.subscribe((contrast) => {
      this.modifyHtmlClass(document.body, 'plus', contrast, ['plus-plus']);
    });

    this.aPlusPlus.subscribe((contrast) => {
      this.modifyHtmlClass(document.body, 'plus-plus', contrast, ['plus']);
    });

    this.searchInTextEmitter.subscribe((inText) => {
      this.searchInText = inText;
    });
  }

  private initData() {
    if (HtmlUtilsService.getFromLocalStorage('high-contrast') === '1') {
      this.modifyHtmlClass(document.body, 'high-contrast', true, []);
      this.contrast = true;
    }
    if (HtmlUtilsService.getFromLocalStorage('plus') === '1') {
      this.modifyHtmlClass(document.body, 'plus', true, ['plus-plus']);
      this.aPlusSize = true;
    }
    if (HtmlUtilsService.getFromLocalStorage('plus-plus') === '1') {
      this.modifyHtmlClass(document.body, 'plus-plus', true, ['plus']);
      this.aPlusPlusSize = true;
    }
    this.searchInText = false;
  }

  public static getFromLocalStorage(key: string): string | null {
    return localStorage.getItem(key);
  }

  public static addToLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public removeClass(target: any, clazz: string, setInLocalStorage: boolean = true) {
    this.renderer.removeClass(target, clazz);
    if (setInLocalStorage) {
      HtmlUtilsService.addToLocalStorage(clazz, '0');
    }
  }

  public addClass(target: any, clazz: string, setInLocalStorage: boolean = true) {
    if (!target.hasOwnProperty(clazz)) {
      this.renderer.addClass(target, clazz);
      if (setInLocalStorage) {
        HtmlUtilsService.addToLocalStorage(clazz, '1');
      }
    }
  }

  private modifyHtmlClass(target: any, clazz: string, add: boolean, toRemove: string[]) {
    if (add) {
      this.addClass(target, clazz);
      if (toRemove) {
        for (const clazz of toRemove) {
          this.removeClass(target, clazz);
        }
      }
    } else {
      this.removeClass(target, clazz);
    }
  }

  public static getSearchUrl(url): string {
    if (url) {
      if (url.startsWith('/b')) {
        return '/search/b/';
      } else {
        return '/search/s/';
      }
    }
  }

  public addScriptToHeader(script: HTMLScriptElement) {
    const head: HTMLElement = document.getElementsByTagName('head')[0];
    const scriptCopy = document.createElement('script');
    scriptCopy.type = script.type ? script.type : 'text/javascript';
    scriptCopy.src = script.src;
    scriptCopy.async = script.async;
    scriptCopy.defer = script.defer;
    head.appendChild(scriptCopy);
  }

  public numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  public toggleVisibleDiv(elId): void {

    const x = document.getElementById(elId);
    if (x.style.display === 'none' || !x.style.display) {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  }

  public toggleVisible(elId): void {
    const x = document.getElementById(elId);
    if (x.getAttribute('type') === 'password') {
      x.setAttribute('type', 'text');
    } else {
      x.setAttribute('type', 'password');
    }
  }

  public static createUrl(url: string): string | undefined {
    if (url) {
      let result = url;
      if (url.startsWith('www.') || !url.startsWith('http')) {
        result = 'http://' + url;
      }
      return `${result}`;
    }
    return undefined;
  }
}
